module.exports = __webpack_public_path__ + "img/seminar (17).37be1312.jpg";